import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]

import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import OperatorAvatar from "~/chat/vue/widget/tabs/chat/OperatorAvatar.vue";
import {MessageReactionInterface} from "~/chat/ts/data/chat/IMessage";
import {IOperator} from "~/chat/ts/data/IOperator";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import {setMessageReaction} from "~/chat/ts/service/messages/setMessageReaction";
import {ref} from "vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ChatMessageReactions"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {}
  },
  setup(__props: any) {

let props = __props;

function getOperatorByReaction(reaction: MessageReactionInterface): IOperator | null {
    if (reaction.isFromOperator && reaction.operatorId) {
        return OperatorsStore.getOperatorById(reaction.operatorId);
    }
    return null;
}

let reactionsKey = ref<number>();

function removeReaction(reaction: MessageReactionInterface) {
    if (reaction.isFromClient) {
        setMessageReaction(props.message, null);
        reactionsKey.value = Date.now();
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    key: _unref(reactionsKey),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.reactions, (reaction) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({'reaction': true, 'cursor-pointer': reaction.isFromClient}),
        onClick: ($event: any) => (removeReaction(reaction))
      }, [
        _createVNode(ChatHtmlify, {
          emoji: "",
          value: reaction.emoji
        }, null, 8, ["value"]),
        (reaction.isFromOperator)
          ? (_openBlock(), _createBlock(OperatorAvatar, {
              key: 0,
              src: getOperatorByReaction(reaction)?.avatar,
              name: getOperatorByReaction(reaction)?.fio,
              size: "2.5em",
              "without-border": ""
            }, null, 8, ["src", "name"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    }), 256))
  ]))
}
}

})